import React from 'react';
import PropTypes from 'prop-types';

import { TableWrapper } from './css';
import TableHeader from './tableHeader';
import TableBody from './tableBody';
import Pagination from './pagination';
// import PaginationNew from './pagination1';

const Table = ({
  title,
  header,
  data,
  actions,
  dataModel,
  currentPage,
  step,
  count,
  url,
  actionsDisplay
}) => {
  // @Todo Sorting need to be done on backend side first
  // const [sort, setSort] = useState(defaultSort);
  // const { index, dir } = sort;
  // const sortIcon = dir ? '↑' : '↓';
  // const onClick = indexNew => {
  //   const sortNew = { index: indexNew };
  //   sortNew.dir = index === indexNew ? !dir : true;
  //   setSort(sortNew);
  // };
  const keys = Object.keys(header);
  let heading = `${title}`;
  if (title && count) heading += ` (${count})`;
  return (
    <>
      <TableWrapper>
        <TableHeader
          heading={heading}
          keys={keys}
          data={header}
          // onClick={onClick}
          // sortIndex={index}
          // sortIcon={sortIcon}
        />
        <TableBody
          keys={keys}
          data={data}
          actions={actions}
          dataModel={dataModel}
          currentPage={currentPage}
          step={step}
          actionsDisplay={actionsDisplay}
        />
      </TableWrapper>
      <Pagination
        currentPage={currentPage}
        step={step}
        count={count}
        url={url}
      />
    </>
  );
};

Table.propTypes = {
  title: PropTypes.string,
  header: PropTypes.objectOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  actions: PropTypes.func,
  defaultSort: PropTypes.shape({
    index: PropTypes.string,
    dir: PropTypes.bool
  }),
  dataModel: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  currentPage: PropTypes.number,
  step: PropTypes.number,
  count: PropTypes.number,
  url: PropTypes.string,
  actionsDisplay: PropTypes.string
};

Table.defaultProps = {
  title: '',
  defaultSort: {
    index: 'first_name',
    dir: false
  },
  dataModel: {},
  currentPage: 1,
  step: 100,
  count: 0,
  url: '',
  actions: () => {},
  actionsDisplay: 'flex'
};

export default Table;
